import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Challenge, DailyChallengeContent } from '../../services/models/challenges.model';

@Component({
  selector: 'app-challenges-daily-card',
  templateUrl: './challenges-daily-card.component.html',
  styleUrls: ['./challenges-daily-card.component.scss']
})
export class ChallengesDailyCardComponent {
  @Input() challenge: Challenge<DailyChallengeContent>;
  @Output() createChallenge = new EventEmitter<void>();
  @Output() updateChallenge = new EventEmitter<void>();
  @Output() deleteChallenge = new EventEmitter<void>();

  handleCreateButtonClick() {
    this.createChallenge.emit();
  }

  handleDelete() {
    this.deleteChallenge.emit();
  }

  handleUpdate() {
    this.updateChallenge.emit();
  }
}
